export default __webpack_public_path__ + "static/media/zhongli-poster.903d3482.jfif";